export default __webpack_public_path__ + "static/media/Rentrée-scolaire.d02ae222.jpg";